var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"tag is-link",attrs:{"href":_vm.shopURL,"target":"_blank"}},[_vm._m(0),_c('span',[_vm._v("#"+_vm._s(_vm.orderNumber))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"far fa-shopping-cart"})])
}]

export { render, staticRenderFns }